var map = {
	"./GDRecruitments.json": 2436,
	"./a24EventRegister.json": 4986,
	"./a25EventRegister.json": 4864,
	"./a25certificate.json": 6621,
	"./a25tsummitWelcome.json": 3695,
	"./cap24WelcomeMail.json": 7537,
	"./cap25WelcomeMail.json": 580,
	"./certificatesA24.json": 201,
	"./envisionRecruitment25.json": 1790,
	"./hackSummitTeamInvite.json": 1570,
	"./mail.json": 3747,
	"./teacherday.json": 7064,
	"./teachersdaymain.json": 3434,
	"./template.json": 9058,
	"./templated.json": 8770,
	"./tsummitregdComplete.json": 934,
	"./tsummitwelcome.json": 1041
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8567;